import type { ReportBlock } from '@/lib/types/report'
import { StatTile } from '../primitives/StatTile'

interface Tile {
  key: string
  label: string
  value: string
  unit: string | null
}

export function KpiGrid({ block }: { block: ReportBlock }) {
  const tiles = (block.data.tiles as Tile[]) ?? []
  if (tiles.length === 0) return null
  return (
    <div className="flex flex-wrap gap-3">
      {tiles.map((t) => (
        <StatTile key={t.key} label={t.label} value={t.value} unit={t.unit ?? undefined} />
      ))}
    </div>
  )
}
